function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { DateTime, Duration } from 'luxon';
import tzlookup from 'tz-lookup';

var Race = function Race(props, tracks) {
  var _this = this;

  _classCallCheck(this, Race);

  _defineProperty(this, "eventName", function () {
    var raceName = _this.name;

    if (!raceName || raceName === '') {
      if (_this.category === 'Practice') {
        raceName = _this.category;
      } else {
        if (_this.series && _this.series !== '') {
          raceName = "".concat(_this.region, " ").concat(_this.series);
        } else {
          raceName = "".concat(_this.region, " ").concat(_this.category);
        }
      }
    }

    return raceName;
  });

  _extends(this, props);

  var track = tracks.find(function (t) {
    return t.name === props.trackname;
  });
  var opts = {};

  if (track) {
    try {
      var zone = tzlookup(track.latitude, track.longitude);
      opts.zone = zone;
    } catch (err) {
      console.error(err);
    }
  }

  if (props.begins_on) {
    this.begins_on = DateTime.fromISO(props.begins_on, opts);
  }

  if (props.ends_on) {
    this.ends_on = DateTime.fromISO(props.ends_on, opts);
  }

  if (props.starttime) {
    this.starttime = DateTime.fromMillis(props.starttime * 1000, opts).minus(Duration.fromMillis(3600000));
  }

  if (props.stoptime) {
    this.stoptime = DateTime.fromMillis(props.stoptime * 1000, opts).minus(Duration.fromMillis(3600000));
  }

  if (this.trackname === 'Tri-City BMX' && this.category === 'Practice') {
    // Track operator indicated the practice time is incorrect, even though it comes back from USABMX as 6pm.
    this.starttime = this.starttime.minus(Duration.fromMillis(1800000));
    this.stoptime = this.starttime.minus(Duration.fromMillis(1800000));
  }
};

export default Race;